före wrapper
<div class="wrapper">
    före drawflow
    <div #drawflow class="node-editor"></div>
    efter drawflow
</div>
efter wrapper